// 攝影機設定 →「卡片照片」（2026-10-16 John：三端卡片圖要同步）：主人選一張照片 → 存雲端，
// 家人的手機和網頁都看到同一張；移除 → 回到產品照。分享者看不到這一區（只有主人能換）。
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../../../lib/api';
import type { DeviceSummary } from '../deviceModel';
import { resolvePanelUrl } from '../panels';
import { SectionCard } from './widgets';

const MAX_BYTES = 10 << 20;

export function DeviceCoverSection({ device, onDeviceUpdate }: { device: DeviceSummary; onDeviceUpdate?: (d: DeviceSummary) => void }) {
  const { t } = useTranslation();
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const cover = device.cover?.url ? resolvePanelUrl(device.cover.url) : null;
  const path = `/v3/devices/${encodeURIComponent(device.device_id)}/cover`;

  const upload = async (f: File) => {
    if (f.size > MAX_BYTES) { setErr(t('deviceCover.tooBig')); return; }
    setBusy(true); setErr(null);
    try {
      const r = await apiFetch<{ url: string; at: number }>(path, { method: 'PUT', rawBody: f });
      onDeviceUpdate?.({ ...device, cover: r.data });
    } catch {
      setErr(t('deviceCover.failed'));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = '';
    }
  };
  const remove = async () => {
    setBusy(true); setErr(null);
    try {
      await apiFetch(path, { method: 'DELETE' });
      onDeviceUpdate?.({ ...device, cover: null });
    } catch {
      setErr(t('deviceCover.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SectionCard title={t('deviceCover.title')}>
      <div data-testid="device-cover" className="dc-row">
        {cover && <img className="dc-preview" src={cover} alt="" data-testid="device-cover-img" />}
        <div className="dc-actions">
          <p className="text-secondary">{t('deviceCover.hint')}</p>
          <input ref={input} type="file" accept="image/jpeg,image/png" hidden data-testid="device-cover-input"
            onChange={(e) => { const f = e.target.files?.[0]; if (f) void upload(f); }} />
          <button className="btn-primary" disabled={busy} onClick={() => input.current?.click()} data-testid="device-cover-pick">
            {busy ? t('deviceCover.saving') : cover ? t('deviceCover.change') : t('deviceCover.pick')}
          </button>
          {cover && (
            <button className="btn-ghost text-danger" disabled={busy} onClick={() => void remove()} data-testid="device-cover-remove">
              {t('deviceCover.remove')}
            </button>
          )}
          {err && <p className="text-danger" role="alert">{err}</p>}
        </div>
      </div>
    </SectionCard>
  );
}
